import { Component, useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Services from "./components/Services";
import Bento from "./components/Bento";
import Gallery from "./components/Gallery";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "sonner";
import "./App.css";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-[#0B0F12] text-white flex flex-col items-center justify-center gap-4 p-8 text-center">
                    <p className="font-display font-bold uppercase text-2xl">One God Roofing Ltd</p>
                    <p className="text-sm text-[#94A3B8]">Something went wrong. Please call us on 055 323 7357.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    const [presetService, setPresetService] = useState("");

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.15 });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);

        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const href = a.getAttribute("href");
            if (href.length > 1 && document.querySelector(href)) {
                e.preventDefault();
                lenis.scrollTo(href, { offset: -70 });
            }
        };
        document.addEventListener("click", onClick);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            document.removeEventListener("click", onClick);
        };
    }, []);

    const bookService = useCallback((name) => {
        setPresetService(name);
        if (window.__lenis) window.__lenis.scrollTo("#contact", { offset: -70 });
        else document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
    }, []);

    return (
        <ErrorBoundary>
            <div className="grain bg-[#0B0F12] min-h-screen">
                <Nav />
                <main>
                    <Hero />
                    <Marquee />
                    <Services onBook={bookService} />
                    <Bento />
                    <Gallery />
                    <Reviews />
                    <Contact presetService={presetService} />
                </main>
                <Footer />
                <Toaster theme="dark" position="bottom-right" />
            </div>
        </ErrorBoundary>
    );
}

export default App;
